module.exports = __webpack_public_path__ + "img/langhe.a749a6be.jpg";